// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SecureMessagingAll-module__font-s-10___nkJgi {
  font-size: 10px !important;
}

.SecureMessagingAll-module__font-s-12___DshTY {
  font-size: 12px !important;
}

.SecureMessagingAll-module__font-s-13___qqDl6 {
  font-size: 13px !important;
}

.SecureMessagingAll-module__font-s-14___LNHEc {
  font-size: 14px !important;
}

.SecureMessagingAll-module__font-s-15___aDeGh {
  font-size: 15px !important;
}

.SecureMessagingAll-module__font-s-16___EH0Aa {
  font-size: 16px !important;
}

.SecureMessagingAll-module__font-s-18___lAWSH {
  font-size: 18px !important;
}

.SecureMessagingAll-module__font-s-20___YmYfi {
  font-size: 20px !important;
}

.SecureMessagingAll-module__font-s-22___ofPGB {
  font-size: 22px !important;
}

.SecureMessagingAll-module__font-s-28___feqOu {
  font-size: 28px !important;
}

.SecureMessagingAll-module__font-w-400___PBB1u {
  font-weight: 400 !important;
}

.SecureMessagingAll-module__font-w-500___llB5Q {
  font-weight: 500 !important;
}

.SecureMessagingAll-module__font-w-600___QQ_lB {
  font-weight: 600 !important;
}

.SecureMessagingAll-module__font-w-700___clDnS {
  font-weight: 700 !important;
}

.SecureMessagingAll-module__p-5___XRveJ {
  padding: 5px !important;
}

.SecureMessagingAll-module__p-12___lDq3h {
  padding: 12px !important;
}

.SecureMessagingAll-module__p-16___cxeHa {
  padding: 16px !important;
}

.SecureMessagingAll-module__p-30___eRb21 {
  padding: 30px !important;
}

.SecureMessagingAll-module__p-b-0___fA9Wz {
  padding-bottom: 0 !important;
}

.SecureMessagingAll-module__p-b-5___nqb1y {
  padding-bottom: 5px !important;
}

.SecureMessagingAll-module__p-b-10___hCvvD {
  padding-bottom: 10px !important;
}

.SecureMessagingAll-module__p-b-12___BDDS_ {
  padding-bottom: 12px !important;
}

.SecureMessagingAll-module__p-b-16___FvAXa {
  padding-bottom: 16px !important;
}

.SecureMessagingAll-module__p-b-18___UOuOC {
  padding-bottom: 18px !important;
}

.SecureMessagingAll-module__p-b-20___Pdkgw {
  padding-bottom: 20px !important;
}

.SecureMessagingAll-module__p-b-25___FBqTZ {
  padding-bottom: 25px !important;
}

.SecureMessagingAll-module__p-b-30___w3FXi {
  padding-bottom: 30px !important;
}

.SecureMessagingAll-module__p-b-50___jG5Y4 {
  padding-bottom: 50px !important;
}

.SecureMessagingAll-module__p-t-0___bZgdt {
  padding-top: 0 !important;
}

.SecureMessagingAll-module__p-t-12___biMDo {
  padding-top: 12px !important;
}

.SecureMessagingAll-module__p-t-16___qJs1u {
  padding-top: 16px !important;
}

.SecureMessagingAll-module__p-t-18___sSWC9 {
  padding-top: 18px !important;
}

.SecureMessagingAll-module__p-t-20___Rlu8Z {
  padding-top: 20px !important;
}

.SecureMessagingAll-module__p-t-30___fuYT7 {
  padding-top: 30px !important;
}

.SecureMessagingAll-module__p-t-40___lBOWh {
  padding-top: 40px !important;
}

.SecureMessagingAll-module__p-t-50___moiJd {
  padding-top: 50px !important;
}

.SecureMessagingAll-module__p-l-20___mOK8l {
  padding-left: 20px !important;
}

.SecureMessagingAll-module__p-l-30___ZJftd {
  padding-left: 30px !important;
}

.SecureMessagingAll-module__p-l-40___Ybhgm {
  padding-left: 40px !important;
}

.SecureMessagingAll-module__p-r-16___Oe62h {
  padding-right: 16px !important;
}

.SecureMessagingAll-module__p-r-20___FEKSp {
  padding-right: 20px !important;
}

.SecureMessagingAll-module__p-r-30___f4M_6 {
  padding-right: 30px !important;
}

.SecureMessagingAll-module__p-r-50___jWKp0 {
  padding-right: 50px !important;
}

.SecureMessagingAll-module__p-r-60___UAgW0 {
  padding-right: 60px !important;
}

.SecureMessagingAll-module__m-b-1___ve4gm {
  margin-bottom: 1px !important;
}

.SecureMessagingAll-module__m-b-2___rhNON {
  margin-bottom: 2px !important;
}

.SecureMessagingAll-module__m-b-6___Reh0F {
  margin-bottom: 6px !important;
}

.SecureMessagingAll-module__m-b-8___nellP {
  margin-bottom: 8px !important;
}

.SecureMessagingAll-module__m-b-10___XdeZp {
  margin-bottom: 10px !important;
}

.SecureMessagingAll-module__m-b-14___beyT0 {
  margin-bottom: 14px !important;
}

.SecureMessagingAll-module__m-b-16___N8F4C {
  margin-bottom: 16px !important;
}

.SecureMessagingAll-module__m-b-20___frPcE {
  margin-bottom: 20px !important;
}

.SecureMessagingAll-module__m-b-22___aWECs {
  margin-bottom: 22px !important;
}

.SecureMessagingAll-module__m-b-24___YKkDj {
  margin-bottom: 24px !important;
}

.SecureMessagingAll-module__m-b-30___B8uPs {
  margin-bottom: 30px !important;
}

.SecureMessagingAll-module__m-b-32___opAkG {
  margin-bottom: 32px !important;
}

.SecureMessagingAll-module__m-b-40___D2jXR {
  margin-bottom: 40px !important;
}

.SecureMessagingAll-module__m-t-2___K9eFu {
  margin-top: 2px !important;
}

.SecureMessagingAll-module__m-t-3___jZD3T {
  margin-top: 3px !important;
}

.SecureMessagingAll-module__m-t-4___qN03D {
  margin-top: 4px !important;
}

.SecureMessagingAll-module__m-t-5___EPasZ {
  margin-top: 5px !important;
}

.SecureMessagingAll-module__m-t-8___Swjlg {
  margin-top: 8px !important;
}

.SecureMessagingAll-module__m-t-10___s97qZ {
  margin-top: 10px !important;
}

.SecureMessagingAll-module__m-t-15___AMlOg {
  margin-top: 15px !important;
}

.SecureMessagingAll-module__m-t-16___x4G_b {
  margin-top: 16px !important;
}

.SecureMessagingAll-module__m-t-20___orFcM {
  margin-top: 20px !important;
}

.SecureMessagingAll-module__m-t-22___FGATe {
  margin-top: 22px !important;
}

.SecureMessagingAll-module__m-t-30___rwpZX {
  margin-top: 30px !important;
}

.SecureMessagingAll-module__m-t-32___EjCda {
  margin-top: 32px !important;
}

.SecureMessagingAll-module__m-l-auto___RJGXK {
  margin-left: auto !important;
}

.SecureMessagingAll-module__m-l-4___TZvFt {
  margin-left: 4px !important;
}

.SecureMessagingAll-module__m-l-5____MCbK {
  margin-left: 5px !important;
}

.SecureMessagingAll-module__m-l-6___KdgAw {
  margin-left: 6px !important;
}

.SecureMessagingAll-module__m-l-8___sMOLo {
  margin-left: 8px !important;
}

.SecureMessagingAll-module__m-l-10___PxsSm {
  margin-left: 10px !important;
}

.SecureMessagingAll-module__m-l-16___lPATe {
  margin-left: 16px !important;
}

.SecureMessagingAll-module__m-l-20___JohXd {
  margin-left: 20px !important;
}

.SecureMessagingAll-module__m-l-24___fguwL {
  margin-left: 24px !important;
}

.SecureMessagingAll-module__m-l-30___MH9md {
  margin-left: 30px !important;
}

.SecureMessagingAll-module__m-l-35___JPzFH {
  margin-left: 35px !important;
}

.SecureMessagingAll-module__m-l-40___jyOzs {
  margin-left: 40px !important;
}

.SecureMessagingAll-module__m-r-8___LfBSk {
  margin-right: 8px !important;
}

.SecureMessagingAll-module__m-r-10___wAv5f {
  margin-right: 10px !important;
}

.SecureMessagingAll-module__m-r-16___EidsQ {
  margin-right: 16px !important;
}

.SecureMessagingAll-module__m-r-20___wIGpg {
  margin-right: 20px !important;
}

.SecureMessagingAll-module__m-r-24___OObxd {
  margin-right: 24px !important;
}

.SecureMessagingAll-module__m-r-30___Db3uh {
  margin-right: 30px !important;
}

.SecureMessagingAll-module__m-r-40___yXqvT {
  margin-right: 40px !important;
}

.SecureMessagingAll-module__border-r-3___jFiG7 {
  border-radius: 3px !important;
}

.SecureMessagingAll-module__border-r-4___GKGBE {
  border-radius: 4px !important;
}

.SecureMessagingAll-module__border-r-6___aoBfK {
  border-radius: 6px !important;
}

.SecureMessagingAll-module__border-r-10___WofHP {
  border-radius: 10px !important;
}

.SecureMessagingAll-module__border-r-12___mk6mX {
  border-radius: 12px !important;
}

.SecureMessagingAll-module__border-r-16___S5phh {
  border-radius: 16px !important;
}

.SecureMessagingAll-module__border-r-50___lUVRB {
  border-radius: 50% !important;
}

.SecureMessagingAll-module__primary-border___si5F1 {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.SecureMessagingAll-module__primary-border-b___psC1M {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.SecureMessagingAll-module__primary-border-t___I0L4o {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.SecureMessagingAll-module__primary-border-l___vg7tz {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.SecureMessagingAll-module__primary-border-r___O7Mq8 {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.SecureMessagingAll-module__secondary-border___Uviyz {
  border: 1px solid #637768;
}

.SecureMessagingAll-module__secondary-border-b___tdwY1 {
  border-bottom: 1px solid #637768;
}

.SecureMessagingAll-module__secondary-border-t___GCjOY {
  border-top: 1px solid #637768;
}

.SecureMessagingAll-module__secondary-border-l___ajd3P {
  border-left: 1px solid #637768;
}

.SecureMessagingAll-module__secondary-border-r___tEWF2 {
  border-right: 1px solid #637768;
}

.SecureMessagingAll-module__gap-0___jybtl {
  gap: 0 !important;
}

.SecureMessagingAll-module__gap-2___Vj_A1 {
  gap: 2px !important;
}

.SecureMessagingAll-module__gap-4___NYsNE {
  gap: 4px !important;
}

.SecureMessagingAll-module__gap-5___O5F9I {
  gap: 5px !important;
}

.SecureMessagingAll-module__gap-6___i6CYv {
  gap: 6px !important;
}

.SecureMessagingAll-module__gap-8___x0v7h {
  gap: 8px !important;
}

.SecureMessagingAll-module__gap-10___ppoxH {
  gap: 10px !important;
}

.SecureMessagingAll-module__gap-12___LFZl1 {
  gap: 12px !important;
}

.SecureMessagingAll-module__gap-14___th9tq {
  gap: 14px !important;
}

.SecureMessagingAll-module__gap-16___wv237 {
  gap: 16px !important;
}

.SecureMessagingAll-module__gap-18___SXEJ_ {
  gap: 18px !important;
}

.SecureMessagingAll-module__gap-20___zFbLm {
  gap: 20px !important;
}

.SecureMessagingAll-module__gap-24___kVgUg {
  gap: 24px !important;
}

.SecureMessagingAll-module__gap-26___Tl7aF {
  gap: 26px !important;
}

.SecureMessagingAll-module__gap-30___qHNAE {
  gap: 30px !important;
}

.SecureMessagingAll-module__gap-32___c3wnH {
  gap: 32px !important;
}

.SecureMessagingAll-module__gap-40___UR3mX {
  gap: 40px !important;
}

.SecureMessagingAll-module__gap-50___jBaAV {
  gap: 50px !important;
}

.SecureMessagingAll-module__flex-1___T6b0y {
  flex: 1;
}

.SecureMessagingAll-module__flex-none___wu4aK {
  flex: none !important;
}

.SecureMessagingAll-module__flex-column___tj5wv {
  display: flex;
  flex-direction: column !important;
}

.SecureMessagingAll-module__flex-row___T9vYi {
  display: flex;
  flex-direction: row !important;
}

.SecureMessagingAll-module__vertically-centered___MpTpO {
  display: flex;
  align-items: center !important;
}

.SecureMessagingAll-module__horizontally-centered___NOSLW {
  display: flex;
  justify-content: center !important;
}

.SecureMessagingAll-module__horizontally-end___lHQSi {
  display: flex;
  justify-content: end !important;
}

.SecureMessagingAll-module__vertically-start___zdzK6 {
  display: flex;
  align-items: start !important;
}

.SecureMessagingAll-module__space-between___A62sN {
  display: flex;
  justify-content: space-between !important;
}

.SecureMessagingAll-module__flex-wrap___XClz1 {
  flex-wrap: wrap !important;
}

.SecureMessagingAll-module__height-100___mdDHi {
  height: 100%;
}

.SecureMessagingAll-module__width-50___fYyzy {
  width: 50% !important;
}

.SecureMessagingAll-module__width-100___YAnR9 {
  width: 100%;
}

.SecureMessagingAll-module__cursor-pointer___CpLDd {
  cursor: pointer;
}

.SecureMessagingAll-module__cursor-not-allowed___w9_aS {
  cursor: not-allowed !important;
}

.SecureMessagingAll-module__absolute-centered___aZ4QM {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.SecureMessagingAll-module__absolute___R1v0m {
  position: absolute;
}

.SecureMessagingAll-module__relative___BciyD {
  position: relative;
}

.SecureMessagingAll-module__fixed___GZaZc {
  position: fixed;
}

.SecureMessagingAll-module__visible___qLdeM {
  opacity: 1;
}

.SecureMessagingAll-module__invisible___N0MMv {
  opacity: 0;
}

.SecureMessagingAll-module__col-90___iZ4aY {
  width: 90% !important;
}

.SecureMessagingAll-module__col-auto___Mdsbs {
  width: auto !important;
}

.SecureMessagingAll-module__medical-tabs___VIlvA {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.SecureMessagingAll-module__medical-table-new___du1Rv {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.SecureMessagingAll-module__medical-table-new___du1Rv:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.SecureMessagingAll-module__medical-table-new___du1Rv::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.SecureMessagingAll-module__medical-table-new___du1Rv::-webkit-scrollbar-track {
  display: none;
}
.SecureMessagingAll-module__medical-table-new___du1Rv.SecureMessagingAll-module__no-pagination___KISsM {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.SecureMessagingAll-module__medical-table-new___du1Rv.SecureMessagingAll-module__no-pagination___KISsM:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.SecureMessagingAll-module__medical-table-new___du1Rv.SecureMessagingAll-module__no-pagination___KISsM::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.SecureMessagingAll-module__medical-table-new___du1Rv.SecureMessagingAll-module__no-pagination___KISsM::-webkit-scrollbar-track {
  display: none;
}

.SecureMessagingAll-module__medical-table-empty___GS_1J {
  padding: 14px 40px !important;
}

.SecureMessagingAll-module__icon-btn___thOUP {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.SecureMessagingAll-module__search-icon___G7Ihw {
  width: 24px;
  height: 24px;
  align-self: center;
}

.SecureMessagingAll-module__disable-select___KMeUz {
  user-select: none;
}

.SecureMessagingAll-module__break-word___PjGCo {
  word-break: break-word;
}

.SecureMessagingAll-module__popup-clear-btn___HAeII {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.SecureMessagingAll-module__scroll-m-b-20___pIXdK {
  scroll-margin-bottom: 20px;
}

.SecureMessagingAll-module__container___u1L9a {
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-height: 0;
}

.SecureMessagingAll-module__title___JWBj_ {
  color: #375844;
}

.SecureMessagingAll-module__table___g0PIF {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination) - 70px);
  overflow-y: scroll;
  overflow-x: hidden;
}
.SecureMessagingAll-module__table___g0PIF:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.SecureMessagingAll-module__table___g0PIF::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.SecureMessagingAll-module__table___g0PIF::-webkit-scrollbar-track {
  display: none;
}

.SecureMessagingAll-module__noPagination___oEyFZ {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - 60px);
  overflow-y: scroll;
  overflow-x: hidden;
}
.SecureMessagingAll-module__noPagination___oEyFZ:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.SecureMessagingAll-module__noPagination___oEyFZ::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.SecureMessagingAll-module__noPagination___oEyFZ::-webkit-scrollbar-track {
  display: none;
}

.SecureMessagingAll-module__pagination___JZKEW {
  justify-content: end;
}

.SecureMessagingAll-module__messagePopupBody___pF1Ft {
  max-width: 760px;
  max-height: 60vh;
  overflow-y: auto;
  padding: 24px 30px 30px;
}

.SecureMessagingAll-module__bubbleRow___oER24 {
  display: flex;
  margin-bottom: 10px;
}

.SecureMessagingAll-module__bubbleRowLeft___LAART {
  justify-content: flex-start;
}

.SecureMessagingAll-module__bubbleRowRight___gNYyu {
  justify-content: flex-end;
}

.SecureMessagingAll-module__bubble___S2d2D {
  max-width: 70%;
  padding: 10px 12px;
  border-radius: 14px;
  white-space: pre-wrap;
  word-break: break-word;
}

.SecureMessagingAll-module__bubbleClinic___KuR8p {
  color: #fff;
  background-color: #375844;
}

.SecureMessagingAll-module__bubbleOther___cfckd {
  color: #375844;
  background-color: #eef3ef;
}

.SecureMessagingAll-module__bubbleMeta___izPQd {
  margin-top: 6px;
  font-size: 12px;
  opacity: 0.75;
}

.SecureMessagingAll-module__attachmentButton___AD5EF {
  margin-top: 8px;
  border: 0;
  padding: 0;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  text-decoration: underline;
  background: transparent;
  color: inherit;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/PatientDetails/fragments/SecureMessagingAll/SecureMessagingAll.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;AA8pBF;;AA3pBA;EACE,cAAA;AA8pBF;;AA3pBA;ECJE,+LDME;ECLF,kBAAA;EACA,kBAAA;ADmqBF;ACjqBE;EACE,oCAAA;EACA,mBAAA;ADmqBJ;AChqBE;EACE,UAAA;EACA,6BAAA;ADkqBJ;AC/pBE;EACE,aAAA;ADiqBJ;;AAnqBA;ECbE,qKDeE;ECdF,kBAAA;EACA,kBAAA;ADorBF;AClrBE;EACE,oCAAA;EACA,mBAAA;ADorBJ;ACjrBE;EACE,UAAA;EACA,6BAAA;ADmrBJ;AChrBE;EACE,aAAA;ADkrBJ;;AA3qBA;EACE,oBAAA;AA8qBF;;AA3qBA;EACE,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;AA8qBF;;AA3qBA;EACE,aAAA;EACA,mBAAA;AA8qBF;;AA3qBA;EACE,2BAAA;AA8qBF;;AA3qBA;EACE,yBAAA;AA8qBF;;AA3qBA;EACE,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,qBAAA;EACA,sBAAA;AA8qBF;;AA3qBA;EACE,WAAA;EACA,yBAAA;AA8qBF;;AA3qBA;EACE,cAAA;EACA,yBAAA;AA8qBF;;AA3qBA;EACE,eAAA;EACA,eAAA;EACA,aAAA;AA8qBF;;AA3qBA;EACE,eAAA;EACA,SAAA;EACA,UAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,uBAAA;EACA,cAAA;AA8qBF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  min-height: 0;\n}\n\n.title {\n  color: #375844;\n}\n\n.table {\n  @include verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) -\n        var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination) - 70px\n    )\n  );\n}\n\n.noPagination {\n  @include verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) -\n        var(--patient-details-footer) - var(--table-tabs) - 60px\n    )\n  );\n}\n\n.pagination {\n  justify-content: end;\n}\n\n.messagePopupBody {\n  max-width: 760px;\n  max-height: 60vh;\n  overflow-y: auto;\n  padding: 24px 30px 30px;\n}\n\n.bubbleRow {\n  display: flex;\n  margin-bottom: 10px;\n}\n\n.bubbleRowLeft {\n  justify-content: flex-start;\n}\n\n.bubbleRowRight {\n  justify-content: flex-end;\n}\n\n.bubble {\n  max-width: 70%;\n  padding: 10px 12px;\n  border-radius: 14px;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.bubbleClinic {\n  color: #fff;\n  background-color: #375844;\n}\n\n.bubbleOther {\n  color: #375844;\n  background-color: #eef3ef;\n}\n\n.bubbleMeta {\n  margin-top: 6px;\n  font-size: 12px;\n  opacity: 0.75;\n}\n\n.attachmentButton {\n  margin-top: 8px;\n  border: 0;\n  padding: 0;\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 600;\n  text-decoration: underline;\n  background: transparent;\n  color: inherit;\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `SecureMessagingAll-module__font-s-10___nkJgi`,
	"fontS12": `SecureMessagingAll-module__font-s-12___DshTY`,
	"fontS13": `SecureMessagingAll-module__font-s-13___qqDl6`,
	"fontS14": `SecureMessagingAll-module__font-s-14___LNHEc`,
	"fontS15": `SecureMessagingAll-module__font-s-15___aDeGh`,
	"fontS16": `SecureMessagingAll-module__font-s-16___EH0Aa`,
	"fontS18": `SecureMessagingAll-module__font-s-18___lAWSH`,
	"fontS20": `SecureMessagingAll-module__font-s-20___YmYfi`,
	"fontS22": `SecureMessagingAll-module__font-s-22___ofPGB`,
	"fontS28": `SecureMessagingAll-module__font-s-28___feqOu`,
	"fontW400": `SecureMessagingAll-module__font-w-400___PBB1u`,
	"fontW500": `SecureMessagingAll-module__font-w-500___llB5Q`,
	"fontW600": `SecureMessagingAll-module__font-w-600___QQ_lB`,
	"fontW700": `SecureMessagingAll-module__font-w-700___clDnS`,
	"p5": `SecureMessagingAll-module__p-5___XRveJ`,
	"p12": `SecureMessagingAll-module__p-12___lDq3h`,
	"p16": `SecureMessagingAll-module__p-16___cxeHa`,
	"p30": `SecureMessagingAll-module__p-30___eRb21`,
	"pB0": `SecureMessagingAll-module__p-b-0___fA9Wz`,
	"pB5": `SecureMessagingAll-module__p-b-5___nqb1y`,
	"pB10": `SecureMessagingAll-module__p-b-10___hCvvD`,
	"pB12": `SecureMessagingAll-module__p-b-12___BDDS_`,
	"pB16": `SecureMessagingAll-module__p-b-16___FvAXa`,
	"pB18": `SecureMessagingAll-module__p-b-18___UOuOC`,
	"pB20": `SecureMessagingAll-module__p-b-20___Pdkgw`,
	"pB25": `SecureMessagingAll-module__p-b-25___FBqTZ`,
	"pB30": `SecureMessagingAll-module__p-b-30___w3FXi`,
	"pB50": `SecureMessagingAll-module__p-b-50___jG5Y4`,
	"pT0": `SecureMessagingAll-module__p-t-0___bZgdt`,
	"pT12": `SecureMessagingAll-module__p-t-12___biMDo`,
	"pT16": `SecureMessagingAll-module__p-t-16___qJs1u`,
	"pT18": `SecureMessagingAll-module__p-t-18___sSWC9`,
	"pT20": `SecureMessagingAll-module__p-t-20___Rlu8Z`,
	"pT30": `SecureMessagingAll-module__p-t-30___fuYT7`,
	"pT40": `SecureMessagingAll-module__p-t-40___lBOWh`,
	"pT50": `SecureMessagingAll-module__p-t-50___moiJd`,
	"pL20": `SecureMessagingAll-module__p-l-20___mOK8l`,
	"pL30": `SecureMessagingAll-module__p-l-30___ZJftd`,
	"pL40": `SecureMessagingAll-module__p-l-40___Ybhgm`,
	"pR16": `SecureMessagingAll-module__p-r-16___Oe62h`,
	"pR20": `SecureMessagingAll-module__p-r-20___FEKSp`,
	"pR30": `SecureMessagingAll-module__p-r-30___f4M_6`,
	"pR50": `SecureMessagingAll-module__p-r-50___jWKp0`,
	"pR60": `SecureMessagingAll-module__p-r-60___UAgW0`,
	"mB1": `SecureMessagingAll-module__m-b-1___ve4gm`,
	"mB2": `SecureMessagingAll-module__m-b-2___rhNON`,
	"mB6": `SecureMessagingAll-module__m-b-6___Reh0F`,
	"mB8": `SecureMessagingAll-module__m-b-8___nellP`,
	"mB10": `SecureMessagingAll-module__m-b-10___XdeZp`,
	"mB14": `SecureMessagingAll-module__m-b-14___beyT0`,
	"mB16": `SecureMessagingAll-module__m-b-16___N8F4C`,
	"mB20": `SecureMessagingAll-module__m-b-20___frPcE`,
	"mB22": `SecureMessagingAll-module__m-b-22___aWECs`,
	"mB24": `SecureMessagingAll-module__m-b-24___YKkDj`,
	"mB30": `SecureMessagingAll-module__m-b-30___B8uPs`,
	"mB32": `SecureMessagingAll-module__m-b-32___opAkG`,
	"mB40": `SecureMessagingAll-module__m-b-40___D2jXR`,
	"mT2": `SecureMessagingAll-module__m-t-2___K9eFu`,
	"mT3": `SecureMessagingAll-module__m-t-3___jZD3T`,
	"mT4": `SecureMessagingAll-module__m-t-4___qN03D`,
	"mT5": `SecureMessagingAll-module__m-t-5___EPasZ`,
	"mT8": `SecureMessagingAll-module__m-t-8___Swjlg`,
	"mT10": `SecureMessagingAll-module__m-t-10___s97qZ`,
	"mT15": `SecureMessagingAll-module__m-t-15___AMlOg`,
	"mT16": `SecureMessagingAll-module__m-t-16___x4G_b`,
	"mT20": `SecureMessagingAll-module__m-t-20___orFcM`,
	"mT22": `SecureMessagingAll-module__m-t-22___FGATe`,
	"mT30": `SecureMessagingAll-module__m-t-30___rwpZX`,
	"mT32": `SecureMessagingAll-module__m-t-32___EjCda`,
	"mLAuto": `SecureMessagingAll-module__m-l-auto___RJGXK`,
	"mL4": `SecureMessagingAll-module__m-l-4___TZvFt`,
	"mL5": `SecureMessagingAll-module__m-l-5____MCbK`,
	"mL6": `SecureMessagingAll-module__m-l-6___KdgAw`,
	"mL8": `SecureMessagingAll-module__m-l-8___sMOLo`,
	"mL10": `SecureMessagingAll-module__m-l-10___PxsSm`,
	"mL16": `SecureMessagingAll-module__m-l-16___lPATe`,
	"mL20": `SecureMessagingAll-module__m-l-20___JohXd`,
	"mL24": `SecureMessagingAll-module__m-l-24___fguwL`,
	"mL30": `SecureMessagingAll-module__m-l-30___MH9md`,
	"mL35": `SecureMessagingAll-module__m-l-35___JPzFH`,
	"mL40": `SecureMessagingAll-module__m-l-40___jyOzs`,
	"mR8": `SecureMessagingAll-module__m-r-8___LfBSk`,
	"mR10": `SecureMessagingAll-module__m-r-10___wAv5f`,
	"mR16": `SecureMessagingAll-module__m-r-16___EidsQ`,
	"mR20": `SecureMessagingAll-module__m-r-20___wIGpg`,
	"mR24": `SecureMessagingAll-module__m-r-24___OObxd`,
	"mR30": `SecureMessagingAll-module__m-r-30___Db3uh`,
	"mR40": `SecureMessagingAll-module__m-r-40___yXqvT`,
	"borderR3": `SecureMessagingAll-module__border-r-3___jFiG7`,
	"borderR4": `SecureMessagingAll-module__border-r-4___GKGBE`,
	"borderR6": `SecureMessagingAll-module__border-r-6___aoBfK`,
	"borderR10": `SecureMessagingAll-module__border-r-10___WofHP`,
	"borderR12": `SecureMessagingAll-module__border-r-12___mk6mX`,
	"borderR16": `SecureMessagingAll-module__border-r-16___S5phh`,
	"borderR50": `SecureMessagingAll-module__border-r-50___lUVRB`,
	"primaryBorder": `SecureMessagingAll-module__primary-border___si5F1`,
	"primaryBorderB": `SecureMessagingAll-module__primary-border-b___psC1M`,
	"primaryBorderT": `SecureMessagingAll-module__primary-border-t___I0L4o`,
	"primaryBorderL": `SecureMessagingAll-module__primary-border-l___vg7tz`,
	"primaryBorderR": `SecureMessagingAll-module__primary-border-r___O7Mq8`,
	"secondaryBorder": `SecureMessagingAll-module__secondary-border___Uviyz`,
	"secondaryBorderB": `SecureMessagingAll-module__secondary-border-b___tdwY1`,
	"secondaryBorderT": `SecureMessagingAll-module__secondary-border-t___GCjOY`,
	"secondaryBorderL": `SecureMessagingAll-module__secondary-border-l___ajd3P`,
	"secondaryBorderR": `SecureMessagingAll-module__secondary-border-r___tEWF2`,
	"gap0": `SecureMessagingAll-module__gap-0___jybtl`,
	"gap2": `SecureMessagingAll-module__gap-2___Vj_A1`,
	"gap4": `SecureMessagingAll-module__gap-4___NYsNE`,
	"gap5": `SecureMessagingAll-module__gap-5___O5F9I`,
	"gap6": `SecureMessagingAll-module__gap-6___i6CYv`,
	"gap8": `SecureMessagingAll-module__gap-8___x0v7h`,
	"gap10": `SecureMessagingAll-module__gap-10___ppoxH`,
	"gap12": `SecureMessagingAll-module__gap-12___LFZl1`,
	"gap14": `SecureMessagingAll-module__gap-14___th9tq`,
	"gap16": `SecureMessagingAll-module__gap-16___wv237`,
	"gap18": `SecureMessagingAll-module__gap-18___SXEJ_`,
	"gap20": `SecureMessagingAll-module__gap-20___zFbLm`,
	"gap24": `SecureMessagingAll-module__gap-24___kVgUg`,
	"gap26": `SecureMessagingAll-module__gap-26___Tl7aF`,
	"gap30": `SecureMessagingAll-module__gap-30___qHNAE`,
	"gap32": `SecureMessagingAll-module__gap-32___c3wnH`,
	"gap40": `SecureMessagingAll-module__gap-40___UR3mX`,
	"gap50": `SecureMessagingAll-module__gap-50___jBaAV`,
	"flex1": `SecureMessagingAll-module__flex-1___T6b0y`,
	"flexNone": `SecureMessagingAll-module__flex-none___wu4aK`,
	"flexColumn": `SecureMessagingAll-module__flex-column___tj5wv`,
	"flexRow": `SecureMessagingAll-module__flex-row___T9vYi`,
	"verticallyCentered": `SecureMessagingAll-module__vertically-centered___MpTpO`,
	"horizontallyCentered": `SecureMessagingAll-module__horizontally-centered___NOSLW`,
	"horizontallyEnd": `SecureMessagingAll-module__horizontally-end___lHQSi`,
	"verticallyStart": `SecureMessagingAll-module__vertically-start___zdzK6`,
	"spaceBetween": `SecureMessagingAll-module__space-between___A62sN`,
	"flexWrap": `SecureMessagingAll-module__flex-wrap___XClz1`,
	"height100": `SecureMessagingAll-module__height-100___mdDHi`,
	"width50": `SecureMessagingAll-module__width-50___fYyzy`,
	"width100": `SecureMessagingAll-module__width-100___YAnR9`,
	"cursorPointer": `SecureMessagingAll-module__cursor-pointer___CpLDd`,
	"cursorNotAllowed": `SecureMessagingAll-module__cursor-not-allowed___w9_aS`,
	"absoluteCentered": `SecureMessagingAll-module__absolute-centered___aZ4QM`,
	"absolute": `SecureMessagingAll-module__absolute___R1v0m`,
	"relative": `SecureMessagingAll-module__relative___BciyD`,
	"fixed": `SecureMessagingAll-module__fixed___GZaZc`,
	"visible": `SecureMessagingAll-module__visible___qLdeM`,
	"invisible": `SecureMessagingAll-module__invisible___N0MMv`,
	"col90": `SecureMessagingAll-module__col-90___iZ4aY`,
	"colAuto": `SecureMessagingAll-module__col-auto___Mdsbs`,
	"medicalTabs": `SecureMessagingAll-module__medical-tabs___VIlvA`,
	"medicalTableNew": `SecureMessagingAll-module__medical-table-new___du1Rv`,
	"noPagination": `SecureMessagingAll-module__no-pagination___KISsM`,
	"medicalTableEmpty": `SecureMessagingAll-module__medical-table-empty___GS_1J`,
	"iconBtn": `SecureMessagingAll-module__icon-btn___thOUP`,
	"searchIcon": `SecureMessagingAll-module__search-icon___G7Ihw`,
	"disableSelect": `SecureMessagingAll-module__disable-select___KMeUz`,
	"breakWord": `SecureMessagingAll-module__break-word___PjGCo`,
	"popupClearBtn": `SecureMessagingAll-module__popup-clear-btn___HAeII`,
	"scrollMB20": `SecureMessagingAll-module__scroll-m-b-20___pIXdK`,
	"container": `SecureMessagingAll-module__container___u1L9a`,
	"title": `SecureMessagingAll-module__title___JWBj_`,
	"table": `SecureMessagingAll-module__table___g0PIF`,
	"noPagination": `SecureMessagingAll-module__noPagination___oEyFZ`,
	"pagination": `SecureMessagingAll-module__pagination___JZKEW`,
	"messagePopupBody": `SecureMessagingAll-module__messagePopupBody___pF1Ft`,
	"bubbleRow": `SecureMessagingAll-module__bubbleRow___oER24`,
	"bubbleRowLeft": `SecureMessagingAll-module__bubbleRowLeft___LAART`,
	"bubbleRowRight": `SecureMessagingAll-module__bubbleRowRight___gNYyu`,
	"bubble": `SecureMessagingAll-module__bubble___S2d2D`,
	"bubbleClinic": `SecureMessagingAll-module__bubbleClinic___KuR8p`,
	"bubbleOther": `SecureMessagingAll-module__bubbleOther___cfckd`,
	"bubbleMeta": `SecureMessagingAll-module__bubbleMeta___izPQd`,
	"attachmentButton": `SecureMessagingAll-module__attachmentButton___AD5EF`
};
module.exports = ___CSS_LOADER_EXPORT___;
